import React from 'react'
import GetRequest from '../Services/APIRequest'
import Loading from '../Components/Loading'
import Error from '../Components/Error'

const ReturnGoodsDetails = () => {
    const orlineId = localStorage.getItem("ditsCurrentOrderLineId");
    const { data, error, isLoaded } = GetRequest(`/ReturnGoods/GetReturnGoodsSummary/${orlineId}`);

    if (error !== null) {
        return <Error data=" " />;
    }
    if (!isLoaded) {
        return <Loading />;
    } else {
        localStorage.removeItem('OredrCartProductData');
    }

    return (
        <>
            <section className="content">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-sm-12">
                            <div className="card card-warning">
                                <div className="card-header">
                                    <h3 className="card-title">Return Goods Request Summary</h3>
                                </div>
                                <div className="card-body">
                                    <div className="row">
                                        <div className="col-sm-12">
                                            <div className="row">
                                                <div className="col-sm-6">
                                                    <p><b className='text-grey-bold'>Request# : </b>{data.result.orderNumber}</p>
                                                    <p><b className='text-grey-bold'>Status : </b>{data.result.status}</p>
                                                    <p><b className='text-grey-bold'>Number of Items : </b>{data.result.numberOfItems}</p>
                                                </div>
                                            </div>

                                            <table className="table table-striped">
                                                <caption style={{ captionSide: "top" }}>
                                                    <span className='text-grey-bold'>
                                                        <b>Products in this Request</b>
                                                    </span>
                                                    <hr className='invLine' />
                                                </caption>
                                                <thead>
                                                    <tr>
                                                        <th className="text-grey-bold">Product Name</th>
                                                        <th className="text-grey-bold">Qty</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {data.result.orderLineItemDTOList && data.result.orderLineItemDTOList.map((item, index) => (
                                                        <tr key={index}>
                                                            <td>{item.productName}</td>
                                                            <td>{item.totalQuantityOrdered}</td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default ReturnGoodsDetails
